import { BASE_URL, getHeaders } from "../utils/serviceHelper";

export const getSyllabusProgress = async (userId, syllabusId) => {
  const res = await fetch(
    `${BASE_URL}/syllabus-progress/progress/${syllabusId}/${userId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      headers: getHeaders(),
    },
  );
  return await res.json();
};

export const getActionableFeedback = async (userId) => {
  const res = await fetch(`${BASE_URL}/actionable-feedback/${userId}`, {
    method: "GET",
    headers: getHeaders(),
  });
  return await res.json();
};

export const addActionableFeedback = async (feedbacks) => {
  const res = await fetch(`${BASE_URL}/actionable-feedback`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(feedbacks),
  });
  return await res.json();
};
